import { MappingSection } from "@/components/ImportComponents/types";
import { SectionProps } from "@/pages/infrastructure/import/templates";

import type { ACCESS_PARENT } from "server/coreApi/accessParents/types.js";
import type { ACCESS_POINT } from "server/coreApi/accessPoints/types.js";
import type { MinimalCustomer } from "server/coreApi/customers/types.js";

import { getEventsColumns } from "./columnFunctions";
import { EVENT_KEY } from "./constants";
import { downloadForEvents } from "./downloadFunctions";

export const getEventsSection = ({
  columns,
}: SectionProps): MappingSection => ({
  key: EVENT_KEY,
  title: "importLabels:eventsMapping",
  isOptional: false,
  sheetSelectLabel: "importLabels:selectEventsSheet",
  columns: columns || [],
  columnSelectLabel: "importLabels:selectEventProperties",
});

export const getTemplates = ({
  customers,
  wasteTypes,
  wasteRooms,
}: {
  customers: MinimalCustomer[];
  wasteTypes: (ACCESS_POINT & { wasteRoom: ACCESS_PARENT })[];
  wasteRooms: ACCESS_PARENT[];
}) => {
  const eventsColumns = getEventsColumns({
    customers,
    wasteTypes,
    wasteRooms,
  });
  const eventsSection = getEventsSection({
    columns: eventsColumns,
  });

  const eventSections: MappingSection[] = [eventsSection];

  return [
    {
      key: "events",
      title: "importLabels:eventsTemplateName",
      downloadFile: downloadForEvents,
      mappingSections: eventSections,
      addedText: "importLabels:eventsImported",
      findResultsText: "importLabels:eventsFindResults",
      findResultsLink: "/events",
      checkCanBeUsed: () => true,
    },
  ];
};
